import { render } from "./AnswerHead.vue?vue&type=template&id=264db07d&scoped=true&ts=true"
import script from "./AnswerHead.vue?vue&type=script&lang=ts"
export * from "./AnswerHead.vue?vue&type=script&lang=ts"

import "./AnswerHead.vue?vue&type=style&index=0&id=264db07d&scoped=true&lang=scss"

import exportComponent from "/Users/lihui/Desktop/project/student_front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-264db07d"]])

export default __exports__